import { FC } from 'react'
import { Container } from '../general/Container.tsx'
import { Editor } from '../general/inputs/Editor.tsx'
import { OutputData } from '@editorjs/editorjs'
import { Poi } from '@/js/types'
import { Label } from '@/components/ui/label.tsx'
import { Input } from '@/components/ui/input.tsx'
import { Textarea } from '@/components/ui/textarea.tsx'
import { Info } from '@/js/editor/components/general/Info.tsx'
import { useSetAtom } from 'jotai'
import { updatePoiDraftAtom } from '@/js/editor/state/poiAtoms.ts'

type PoiFormType = {
    poi: Poi
}

export const PoiDescription: FC<PoiFormType> = ({ poi }) => {
    const updateDraft = useSetAtom(updatePoiDraftAtom)

    return (
        <div className={'flex flex-col space-y-2'}>
            <Container title={'Beschreibung'}>
                <div className="grid pb-3 w-full items-center gap-1.5">
                    <Label htmlFor="title">Titel</Label>
                    <Input
                        type="text"
                        id="title"
                        value={poi.title}
                        onChange={(event) => {
                            updateDraft({ title: event.target.value })
                        }}
                    />
                </div>

                <div className="grid pb-3 w-full items-center gap-1.5">
                    <div className={'flex flex-row gap-3 items-center'}>
                        <Label htmlFor="description">Kurzbeschreibung</Label>
                        <Info
                            description={'Die Kurzbeschreibung wird beim Anklicken direkt auf der Karte angezeigt.'}
                        />
                    </div>
                    <Textarea
                        id="description"
                        value={poi.description ?? ''}
                        onChange={(event) => {
                            updateDraft({ description: event.target.value })
                        }}
                    />
                </div>

                <Editor
                    key={String(poi.id)}
                    onChange={(content: OutputData) => {
                        updateDraft({ content })
                    }}
                    initialData={poi.content as OutputData}
                    readonly={false}
                    label={'Beschreibung'}
                    id={String(poi.id)}
                />
            </Container>
        </div>
    )
}
